import u from 'updeep';
import { handleActions } from 'redux-actions';
import * as actions from './bookActions';
import { receiveCreateReadingList } from './readingListsActions';
import { receiveSearchBooks } from '../redux/expandedSearchActions';
import cloneDeep from 'lodash/cloneDeep';


const initialState = {
  isFetchingBook: false,

  // TODO: save books by slug to avoid race conditions.
  // By extension, everything else gets saved by slug as well.
  book: null,
  isReleveling: false,
  isChangingLanguage: false,
  isAddingToOrRemovingFromEditorsPicks: false,

  // TODO: store these booleans keyed by slug. See next comment for
  // more info.
  isFetchingAssets: false,

  // TODO: store assets keyed by slug, so we can store data
  // for multiple books at a time. This is because books can
  // be read from several pages across the app.
  assets: {},

  // Just a list of books.
  isAddingOrRemovingFromBookshelf: [],

  isLikingBook: false,
  isAddingAward: false,
  isEditingAward: false,
  isBlockingUser: false,
  isBlockingStory: false,
  isResolvingSuggestions: false,
  isSavingContent: false,
  // Keys are strings, representing book slugs. Values are booleans.
  isFlaggingBook: { },
  isEditingBook : { },
  isGlobalNextReadSuggestionsVisible: false,
  isGlobalBookReaderVisible: false,
  showAttributionPage: false,
  isUserBlocked: '',
  showAudioBookReader: false,
  globalBookReaderStartPage: 1,
  isGlobalQuickViewVisible: false,
  currentGlobalQuickViewBook: {},
  isFetchingNextReadBooks: false,
  nextReadBooks: null,
  readingListNextReadBooks: [],
  currentGlobalBookReaderBook: {},
  isSubmittingSmileyRating: false,
  isFetchingSmileyRatingBook: false,
  smileyRatingBook: {},
  currentGlobalBookReaderSlug: "",
  isFetchingBookDownloadLimit: false,
  nextTranslationBooks: null,
  isFetchingNextTranslationBooks: false, 
  isFetchingSuggestions: false,
  suggestions: null,
  isUploadingGatingForm: false,
  isSubmittingTranslationEditorFeedback: false,
  readingProgramBook: false,
  readSource: '',
  isSubmittingOfflineTranslateData: false,
  isFetchingAssetsForOfflineTranslate: false,
  assetsForOfflineTranslate: {},
  isOfflineTranslatorVisible: false,
  currentOfflineTranslatorBook: {},
  offlineTranslatorStartPage: 1,
  currentOfflineTranslatorSlug: "",
  isFetchingAssetsForMobileTranslate: false,
  currentMobileTranslatorSlug: "",
  isVideoPlayerVisible: false,
  isSubmittingOfflineTranslationFeedback: false,
  isFetchingBookShelves: false,
  bookShelfArr: [],
  isAddingToBookshelf: false,
  translatePartner: false,
  eventCategory: ''
};

export default handleActions({
  [actions.fetchBook]: (state, action) => u({
    isFetchingBook: true,
    book: null,
  }, state),

  [actions.receiveBook]: (state, action) => u({
    isFetchingBook: false,
    book: action.payload.book,
  }, state),

  [actions.receiveExtendedBook]: (state, action) => u({
      book: Object.assign({}, state.book, action.payload.data)
    }, state),
  
  [actions.fetchNextReadBooks]: (state, action) => u({
    isFetchingNextReadBooks: true
  }, state),

  [actions.receiveNextReadBooks]: (state, action) => u({
    isFetchingNextReadBooks: false,
    nextReadBooks: action.payload.nextReadBooks
  }, state),

  [actions.fetchSmileyRatingBook]: (state, action) => u({
    isFetchingSmileyRatingBook: true
  }, state),

  [actions.receiveSmileyRatingBook]: (state, action) => u({
    isFetchingSmileyRatingBook: false,
    smileyRatingBook: action.payload.smileyRatingBook
  }, state),

  [actions.fetchBookDownloadLimit]: (state, action) => u({
    isFetchingBookDownloadLimit: true
  }, state),

  [actions.receiveBookDownloadLimit]: (state, action) => u({
    isFetchingBookDownloadLimit: false
  }, state),

  [actions.postRelevel]: (state, action) => u({
    isReleveling: true
  }, state),

  [actions.receivePostRelevel]: (state, action) => {
    let updatedTranslations = state.book.translations.map((translation) => {
      let updatedTranslation = cloneDeep(translation);
      updatedTranslation.level = action.payload.newLevel
      return (updatedTranslation);
    });

    return u({
      isReleveling: false,
      book: {
        level: action.payload.newLevel,
        translations: updatedTranslations
      }
    }, state);
  },

  [actions.postAddAward]: (state, action) => u({
    isAddingAward: true
  }, state),

  [actions.receivePostAddAward]: (state, action) =>  u({
    isAddingAward: false
    }, state),

  [actions.postAddAwardError]: (state, action) => u({
    isAddingAward: false
    }, state),
    
  [actions.postChangeLanguage]: (state, action) => u({
    isChangingLanguage: true
  }, state),

  [actions.receiveChangeLanguage]: (state, action) => {
    
    return u({
      isChangingLanguage: false,
      book: {
        language: action.payload.newLanguage,
      }
    }, state);
  },

  [actions.updateAward]: (state, action) => u({
    isEditingAward: true
  }, state),

  [actions.receiveUpdateAward]: (state, action) =>  u({
    isEditingAward: false
    }, state),

  [actions.updateAwardError]: (state, action) => u({
    isEditingAward: false
    }, state),

  [actions.resolveSuggestions]: (state, action) => u({
    isResolvingSuggestions: true
  }, state),

  [actions.receiveResolveSuggestions]: (state, action) => u({
    isResolvingSuggestions: false
  }, state),

  [actions.resolveSuggestionsError]: (state, action) => u({
    isResolvingSuggestions: false
  }, state), 

  [actions.blockStory]: (state, action) => u({
    isBlockingStory: true
  }, state),

  [actions.receiveBlockStory]: (state, action) => u({
    isBlockingStory: false
  }, state),

  [actions.blockStoryError]: (state, action) => u({
    isBlockingStory: false
  }, state), 


  [actions.blockUser]: (state, action) => u({
    isBlockingUser: true
  }, state),

  [actions.receiveBlockUser]: (state, action) => u({
    isBlockingUser: false
  }, state),

  [actions.blockUserError]: (state, action) => u({
    isBlockingUser: false
  }, state),
    
  [actions.fetchBookAssets]: (state, action) => u({
      isFetchingAssets: true,
      currentGlobalBookReaderSlug: action.payload.slug
    }, state),

  [receiveSearchBooks]: (state, action) => u({
    currentGlobalBookReaderSlug: ''
  }, state),
    
  [actions.receiveBookAssets]: (state, action) => {
    const updatesList = {
      isFetchingAssets: false,
      assets: action.payload.assets
    };


    return u(updatesList, state);
  },

  [actions.fetchBookAssetsForMobileTranslate]: (state, action) => u({
    isFetchingAssetsForMobileTranslate: true,
    currentMobileTranslatorSlug: action.payload.slug
  }, state),
  
  [actions.receiveBookAssetsForMobileTranslate]: (state, action) => u({
    isFetchingAssetsForMobileTranslate: false,
    currentMobileTranslatorSlug: action.payload.slug
  }, state),

  [actions.fetchAssetsForOfflineTranslate]: (state, action) => u({
    isFetchingAssetsForOfflineTranslate: true,
    currentOfflineTranslatorSlug: action.payload.slug
  }, state),
  
  [actions.receiveAssetsForOfflineTranslate]: (state, action) => {
    const updatesList = {
      isFetchingAssetsForOfflineTranslate: false,
      assetsForOfflineTranslate: action.payload.assetsForOfflineTranslate
    };

    return u(updatesList, state);
  },

  [actions.addToEditorsPicks]: (state, action) => u({
    isAddingToOrRemovingFromEditorsPicks: true,
  }, state),

  [actions.receiveAddToEditorsPicks]: (state, action) => u({
    isAddingToOrRemovingFromEditorsPicks: false,
    book: {
      editorsPick: true
    }
  }, state),

  [actions.removeFromEditorsPicks]: (state, action) => u({
    isAddingToOrRemovingFromEditorsPicks: true,
  }, state),

  [actions.receiveRemoveFromEditorsPicks]: (state, action) => u({
    isAddingToOrRemovingFromEditorsPicks: false,
    book: {
      editorsPick: false
    }
  }, state),

  [receiveCreateReadingList]: (state, action) => {
    // If no book is loaded, do nothing.
    if (!state.book) {
      return state;
    }

    // If a book is loaded, but the newly created list doesn't have it
    // in its `lists` array, do nothing.
    const isBookInList = Boolean(
      action.payload.readingList.books.find(b => b.id === state.book.id)
    );
    if (!isBookInList) {
      return state;
    }

    // Otherwise, update list membership.
    return u({
      book: {
        lists: state.book.lists.concat({ slug: action.payload.readingList.slug })
      }
    }, state);
  },

  [actions.likeBook]: (state, action) => u({
    isLikingBook: true
  }, state),

  [actions.receiveLikeBook]: (state, action) => u({
    isLikingBook: false,
    book: {
      liked: true,
      likesCount: state.book.likesCount + 1
    }
  }, state),

  [actions.postFlagBook]: (state, action) => u({
    isFlaggingBook: {
      [action.payload.bookSlug]: true
    }
  }, state),

  [actions.receivePostFlagBook]: (state, action) => u({
    book: {
      isFlagged: true
    },
    isFlaggingBook: {
      [action.payload.bookSlug]: false
    }
  }, state),

  [actions.postFlagBookError]: (state, action) => u({
    isFlaggingBook: {
      [action.payload.bookSlug]: false
    }
  }, state),

  [actions.postEditBook]: (state, action) => u({
    isEditingBook: {
      [action.payload.bookSlug]: true
    }
  }, state),
  
  [actions.receivePostEditBook]: (state, action) => u({
    isEditingBook: {
      [action.payload.bookSlug]: false
    }
  }, state),
  
  [actions.postEditBookError]: (state, action) => u({
    isEditingBook: {
      [action.payload.bookSlug]: false
    }
  }, state),

  [actions.postSmileyRating]: (state, action) => u({
    isSubmittingSmileyRating: true
  }, state),

  [actions.receivePostSmileyRating]: (state, action) => u({
    isSubmittingSmileyRating: false
  }, state),

  [actions.postSmileyRatingError]: (state, action) => u({
    isSubmittingSmileyRating: false
  }, state),

  [actions.postTranslationEditorFeedback]: (state, action) => u({
    isSubmittingTranslationEditorFeedback: true
  }, state),

  [actions.receivePostTranslationEditorFeedback]: (state, action) => u({
    isSubmittingTranslationEditorFeedback: false
  }, state),

  [actions.postTranslationEditorFeedbackError]: (state, action) => u({
    isSubmittingTranslationEditorFeedback: false
  }, state),

  [actions.postGatingFormData]: (state, action) => u({
    isUploadingGatingForm: true
  }, state),

  [actions.receivePostGatingFormData]: (state, action) => u({
    isUploadingGatingForm: false,
  }, state),

 [actions.postGatingFormDataError]: (state, action) => u({
    isUploadingGatingForm: false,
    uploadErrors: action.payload
  }, state),

  [actions.postOfflineTranslateData]: (state, action) => u({
    isSubmittingOfflineTranslateData: true
  }, state),

  [actions.receivePostOfflineTranslateData]: (state, action) => u({
    isSubmittingOfflineTranslateData: false,

  }, state),

 [actions.postOfflineTranslateDataError]: (state, action) => u({
   isSubmittingOfflineTranslateData: false,
  }, state),

  [actions.openGlobalBookReader]: (state, action) => u({
    isGlobalBookReaderVisible: true,
    currentGlobalBookReaderBook: action.payload.book,
    showAudioBookReader: action.payload ? action.payload.showAudioBookReader : false,
    showAttributionPage: action.payload ? action.payload.showAttributionPage : false,
    readingProgramBook: action.payload ? action.payload.readingProgramBook : false,
    translatePartner: action.payload ? action.payload.translatePartner: false,
    storyId: action.payload? action.payload.storyId: '',
    enrollmentId: action.payload ? action.payload.enrollmentId: '',
    themeNumber: action.payload ? action.payload.themeNumber: '',
    themeName: action.payload ? action.payload.themeName: '',
    fluencyNumber: action.payload ? action.payload.fluencyNumber: '',
    globalBookReaderStartPage: (action.payload && action.payload.startPage) || 1,
    readingListNextReadBooks: (action.payload && action.payload.readingListNextReadBooks),
    readSource: action.payload ? action.payload.readSource : '',
    mobileTranslate: action.payload ? action.payload.mobileTranslate : false,
    flpBook: action.payload ? action.payload.flpBook : false,
    regId: action.payload ? action.payload.regId: '',
    disableNextRead: action.payload.disableNextRead,
    isOfflineRp: action.payload.isOfflineRp,    
    campaignType: action.payload ? action.payload.campaignType: '',
    isSupplementary: action.payload ? action.payload.isSupplementary : false
  }, state),

  [actions.closeGlobalBookReader]: (state, action) => u({
    isGlobalBookReaderVisible: false,
    showAudioBookReader: false,
    assets: null,
    globalBookReaderStartPage: 1
  }, state),
  
  [actions.userBlockedById]: (state, action) => u({
    isUserBlocked: action.payload ? action.payload.isUserBlocked: '',
  }, state),

  [actions.openNextReadSuggestions]: (state, action) => u({
    isGlobalNextReadSuggestionsVisible: true
  }, state),

  [actions.closeNextReadSuggestions]: (state, action) => u({
    isGlobalNextReadSuggestionsVisible: false
  }, state),

  [actions.fetchNextTranslationBooks]: (state, action) => u({
    isFetchingNextTranslationBooks: true,
  }, state),

  [actions.receiveNextTranslationBooks]: (state, action) => u({
    isFetchingNextTranslationBooks : false,
    nextTranslationBooks: action.payload.nextTranslationBooks
  }, state),

  [actions.openGlobalQuickView]: (state, action) => u({
    isGlobalQuickViewVisible: true,
    currentGlobalQuickViewBook: action.payload.book,
    readSource: action.payload.readSource,
    eventCategory: action.payload.eventCategory,
    isSupplementary: action.payload.isSupplementary
  }, state),

  [actions.closeGlobalQuickView]: (state, action) => u({
    isGlobalQuickViewVisible: false,
    currentGlobalQuickViewBook: null,
    readSource: '',
    eventCategory: ''
  }, state),

  [actions.fetchSuggestions]: (state, action) => u({
    isFetchingSuggestions : true,
    suggestions: null
  }, state),

  [actions.receiveSuggestions]: (state, action) => u({
    isFetchingSuggestions : false,
    suggestions: action.payload.suggestions
  }, state),

  [actions.resetSuggestions]: ( state, action ) => u({ 
    suggestions : null 
  } , state ),

  [actions.updateReviewerSuggestions]: (state, action) => {
    const reviewerSuggestions = state.assets.reviewerSuggestions === null ? [] : state.assets.reviewerSuggestions
    // Otherwise, update reviewerSuggestion
    return u({
      assets : {
        reviewerSuggestions: reviewerSuggestions.concat(action.payload.suggestionId)
      }
    }, state);
  },

  [actions.updatePageContent]: (state, action) =>  {
    return u({
      assets : {
        pages : state.assets.pages.map((page) => {
          if(page.pageId === action.payload.pageId) {
            return {
              ...page,
              html: action.payload.updatedContent  
            }
          }
          return page
        })
      }
    }, state);
  } , 

  [actions.removeFromBookshelf]: (state, action) => u({
    isAddingToBookshelf: true,
    isAddingOrRemovingFromBookshelf: [].concat(state.isAddingOrRemovingFromBookshelf, action.payload.bookSlug)
  }, state),

  [actions.receiveRemoveFromBookshelf]: (state, action) => u({
    isAddingToBookshelf: false,
    isAddingOrRemovingFromBookshelf: action.payload.data ? action.payload.data.stories : []
  }, state),

  [actions.openOfflineTranslator]: (state, action) => u({
    isOfflineTranslatorVisible: true,
    currentOfflineTranslatorBook: action.payload.book,
    offlineTranslatorStartPage: (action.payload && action.payload.startPage) || 2,
  }, state),

  [actions.closeOfflineTranslator]: (state, action) => u({
    isOfflineTranslatorVisible: false,
    currentOfflineTranslatorBook: null,
    offlineTranslatorStartPage: 2,
  }, state),

  [actions.openVideoPlayer]: (state, action) => u({
    isVideoPlayerVisible: true,
  }, state),

  [actions.closeVideoPlayer]: (state, action) => u({
    isVideoPlayerVisible: false,
  }, state),

  [actions.postOfflineTranslationFeedback]: (state, action) => u({
    isSubmittingOfflineTranslationFeedback: true
  }, state),

  [actions.receivePostOfflineTranslationFeedback]: (state, action) => u({
    isSubmittingOfflineTranslationFeedback: false
  }, state),

  [actions.postOfflineTranslationFeedbackError]: (state, action) => u({
    isSubmittingOfflineTranslationFeedback: false
  }, state),

  [actions.getBookshelfList]: (state, action) => u({
    isFetchingBookShelves: true
  }, state),

  [actions.receiveGetBookshelfList]: (state, action)=> u({
    isFetchingBookShelves: false,
    bookShelfArr: action.payload.data
  }, state),

  [actions.getBookshelfAutocomplete]: (state, action) => u({
    isFetchingBookShelves: true 
  }, state),

  [actions.receiveGetBookshelfAutocomplete]: (state, action) => u({
    isFetchingBookShelves: false,
    bookShelfArr: action.payload.data
  }, state),
  [actions.addNewBookToBookshelf]: (state, action) => u({
    isAddingToBookshelf: true
  }, state),
  [actions.receiveAddNewBookToBookshelf] : (state, action) => u({
    isAddingToBookshelf: false,
    isAddingOrRemovingFromBookshelf: action.payload.data ? action.payload.data.stories : []
  }, state),
  [actions.addBookshelf]: (state, action) => u({
    isAddingToBookshelf: true
  }, state),
  [actions.receiveAddBookshelf]: (state, action) => u({
    isAddingToBookshelf: false
  }, state),

  [actions.postImageGatingFormData]: (state, action) => u({
    isUploadingGatingForm: true
  }, state),

  [actions.receivePostImageGatingFormData]: (state, action) => u({
    isUploadingGatingForm: false,
  }, state),

 [actions.postImageGatingFormDataError]: (state, action) => u({
    isUploadingGatingForm: false,
  }, state),
}, initialState);



// WEBPACK FOOTER //
// ./src/redux/bookReducer.js